import store from "../store";
import { isImpersonating } from "../utilities";
import { RequestContext } from "./requestContext";

export const getRequestContext = function (): RequestContext {
    const impersonating = isImpersonating();
    const loggedInUserRetireeId = store.state.user.id;
    const subjectRetireeId = impersonating ? store.state.impersonatingId as number : loggedInUserRetireeId;
    return new RequestContext(impersonating, loggedInUserRetireeId, subjectRetireeId);
}
